import DataTable from "@/components/ui/DataTable";
import { LeaveRequest } from "@/models/leave-requests.model";
import React from "react";
import { columns } from "./columns";

interface Props {
  leaveRequests: LeaveRequest[];
}
function IndivLeaveRequestDataTable({ leaveRequests }: Props) {
  return (
    <DataTable
      tableMinWidth="500px"
      containerClassname="h-fit max-h-full overflow-y-auto relative"
      columns={columns}
      data={leaveRequests}
    />
  );
}

export default IndivLeaveRequestDataTable;
